// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import ListOrder from './ListOrder';

export default compose(
  connect(
    state => ({
      stores: state?.stores?.stores || []
    }),
    dispatch => ({}),
  ),
)(ListOrder);
